export enum AIAssistantMutationTypes {
  SET_QUESTION_TYPE = 'SET_QUESTION_TYPE',
  SET_CONVERSATION_ACTIVE_ID = 'SET_CONVERSATION_ACTIVE_ID',
  SET_CONVERSATION_MESSAGES_PENDING = 'SET_CONVERSATION_MESSAGES_PENDING',
  SET_CONVERSATIONS_PENDING = 'SET_CONVERSATIONS_PENDING',
  SET_PANE_OPENED = 'SET_PANE_OPENED',
  SET_POST_PROMPT_PENDING = 'SET_POST_PROMPT_PENDING',
  SET_POST_PROMPT_STREAMING = 'SET_POST_PROMPT_STREAMING',
  SET_CREDITS = 'SET_CREDITS',
  SET_CREDITS_PENDING = 'SET_CREDITS_PENDING',
  SET_CREDITS_REMAINING = 'SET_CREDITS_REMAINING',
  SET_PENDING_CONVERSATION_ID = 'SET_PENDING_CONVERSATION_ID',
}
